import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import { getMerchantsListService } from '../services/merchant.service';
import { TGetMerchantsListParams, TGetMerchantsListResData } from '../types/merchant.types';

export const merchantQueryKeys = createQueryKeys(EQueryKeys.MerchantQueryKeys, {
  getMerchantsList: (counterpartyGUID: string, params: TGetMerchantsListParams) => ({
    queryKey: ['get-merchants-list', counterpartyGUID, params],
    queryFn: (): Promise<TGetMerchantsListResData> => getMerchantsListService(counterpartyGUID, params),
  }),
});
